import React from 'react';

export default function PoolsList({ pools, selectedPoolId, setSelectedPoolId, setActiveTab, userRole }) {
  return (
    <div className="admin-card pools-sidebar">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
        <h2 style={{width:"100%", display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
          Pools
          {userRole === 'admin' && (
            <button className="btn-small btn-success" onClick={() => setActiveTab('create-pool')} style={{ margin: 0 }}>
              <i className="fas fa-plus"></i> Add
            </button>
          )}
        </h2>
      </div>
      
      <div className="pools-list-container" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {pools.map(pool => {
          // STRICT MATCHING TO YOUR API RESPONSE
          const pId = pool._id || pool.id;
          const pName = pool.Name || pool.name;
          const pTitle = pool.Title || pool.title;

          return (
            <div
              key={pId}
              className={`pool-list-item ${selectedPoolId === pId ? 'active' : ''}`}
              onClick={() => setSelectedPoolId(pId)}
              style={{ padding: '12px', border: '1px solid rgba(255,255,255,0.05)', borderRadius: '8px', cursor: 'pointer', backgroundColor: selectedPoolId === pId ? 'rgba(255,255,255,0.1)' : 'transparent' }}
            >
              <strong style={{ display: 'block', fontSize: '1.1rem', color: selectedPoolId === pId ? 'var(--accent-gold)' : 'white' }}>
                {pName}
              </strong>
              <small style={{ color: 'var(--text-gray)', display: 'block' }}>
                {pTitle}
              </small>
            </div>
          );
        })}
      </div>
    </div>
  );
}